import React from 'react';

import styled from 'styled-components';

import calendar from 'assets/images/icons/calendar.png';

const CalendarIcon = (props) => <Icon src={calendar} {...props} />;

const Icon = styled.img`
	height: 30px;
	width: 30px;
`;

export default CalendarIcon;
